export const TOGGLE_CITY_INFORMATIONS_DETAIL_PANEL = 'TOGGLE_CITY_INFORMATIONS_DETAIL_PANEL'

export function displayCityInformationsDetailsPanelReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_CITY_INFORMATIONS_DETAIL_PANEL:
            return !state
        default: return state
    }
}